import { StaticLabel } from "@pjs/core-ui";
import { react2angular } from "@pebblepad/react2angular";
import { angularAMD } from "@pebblepad/amd";
angularAMD.component("staticLabel", react2angular(StaticLabel, ["text", "dataHook"]));
